import { render, staticRenderFns } from "./record_details.vue?vue&type=template&id=4f3377b8&"
import script from "./record_details.vue?vue&type=script&lang=js&"
export * from "./record_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports